namespace GeniuzPOS.Administration {
    export interface CsVatTypeForm {
        VatType: Serenity.StringEditor;
        VatTypeDesc: Serenity.StringEditor;
    }

    export class CsVatTypeForm extends Serenity.PrefixedContext {
        static formKey = 'Administration.CsVatType';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!CsVatTypeForm.init)  {
                CsVatTypeForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;

                Q.initFormType(CsVatTypeForm, [
                    'VatType', w0,
                    'VatTypeDesc', w0
                ]);
            }
        }
    }
}
